export default __webpack_public_path__ + "style-osm-500-982cbe64d1354b85f6fb614d38d040cf.png";